export function isReactText(children) {
  return ['string', 'number'].includes(typeof children);
}
